export const VIDEO_ASSET_TYPES = ['mp4', 'mov', 'gif']

export const usageRightsInfoColumns = [
  {
    id: 'drmId',
    class: 'drmId',
    label: 'DRM ID',
  },
  {
    id: 'buyer',
    class: 'usageText',
    label: 'Buyer',
  },
  {
    id: 'rightsHolderName',
    class: 'usageText',
    label: 'Rights holder name',
  },
  {
    id: 'rightsHolderType',
    class: 'usageText',
    label: 'Rights holder type',
  },
  {
    id: 'availableChannels',
    class: 'usageText',
    label: 'Available channels',
  },
  {
    id: 'availableTerritories',
    class: 'usageText',
    label: 'Available territories',
  },
  {
    id: 'expirationDate',
    class: 'usageText',
    label: 'Expiration date',
  },
  {
    id: 'urmLanguage',
    class: 'urmLangText',
    label: 'Usage Rights Language',
  },
]

export const DEFAULT_SEARCH_TYPE = 'ALL'
export const DEFAULT_SEARCH_RENDER_PAGE = 'SEARCH'
export const DEFAULT_PAGE = Number(0)
export const DEFAULT_ROWSPERPAGE = Number(100)
export const SEARCH_PAGE_SIZES = [20, 50, 100, 200]
export const SORT_OPTIONS = {
  relevance: 'Relevance',
  uploadDateASC: 'Date | Old to New',
  uploadDateDESC: 'Date | New to Old',
  fileNameASC: 'Name | A-Z',
  fileNameDESC: 'Name | Z-A',
}

export const SORT_BY_OPTIONS = {
  uploadDateASC: { uploadedDate: 'asc' },
  uploadDateDESC: { uploadedDate: 'desc' },
  fileNameASC: { 'metadata.fileMetadata.fileName': 'asc' },
  fileNameDESC: { 'metadata.fileMetadata.fileName': 'desc' },
  relevance: {},
}

export const DEFAULT_SORT_BY_OPTION = 'relevance'
export const DEFAULT_BRAND_SORT_BY_OPTION = 'uploadDateDESC'
export const SEARCH_TEXT = 'SEARCH_TEXT'
export const UPLOAD_DATE_TEXT = 'UPLOAD_DATE'

export const FILTER_CHANNEL_KEY = 'metadata.projectInfo.channel'
export const FILTER_BRAND_KEY = 'metadata.itemInfo.brand.nested'
export const FILTER_DEPARTMENT_KEY =
  'metadata.itemInfo.merchandiseClassification.departmentName.nested'
export const FILTER_CLASS_KEY =
  'metadata.itemInfo.merchandiseClassification.className.nested'
export const FILTER_SUBCLASS_KEY =
  'metadata.itemInfo.merchandiseClassification.subclass.nested'
export const FILTER_FILE_TYPE_KEY = 'metadata.fileMetadata.fileType'

// ============================================================================
// CHANNEL FILTER CONFIGURATION (FALLBACK DEFAULTS)
// ============================================================================
// NOTE: These constants serve as FALLBACK values when environment configuration
// is unavailable. The primary source for channel configuration is:
// config.json → SEARCH_CONFIG.CHANNEL_GROUPS/CHANNEL_NAME_MAPPING/EXCLUDED_CHANNELS
//
// To modify channel configuration for a specific environment (dev/stage/prod),
// update the respective config.json file instead of these constants.
// ============================================================================

// Channel mapping: Maps variant/old channel names to canonical names
// Used for data normalization and backward compatibility
// NOTE: Only variant mappings are stored here. Canonical names that don't have
// variants are handled automatically by the mapping logic (if not found in map,
// the name is treated as canonical).
export const CHANNEL_NAME_MAPPING = {
  // Cross Channel variants
  'Cross Channel & Contract Fees': 'Cross Channel',
  'Cross-Channel': 'Cross Channel',

  // Experiential variants
  'Experiential Marketing': 'Experiential',

  // Store Experience Marketing variants (formerly "In Store Marketing")
  'In Store Marketing': 'Store Experience Marketing',
  'in Store Marketing': 'Store Experience Marketing',

  // Outtakes variants
  'Promo Outtakes': 'Outtakes',

  // Promo Marketing variants
  'Promo': 'Promo Marketing',
  'Target Branded Assets': 'Promo Marketing',

  // Roundel variants
  'Roundel Metadata Tagging': 'Roundel',

  // Target.com PDP channels (renamed)
  'Target.com': 'National Brand Target.com PDP',
  'TCIN Photography': 'Owned Brand Target.com PDP',
}

// Channels to exclude from display (outdated/deprecated channels)
export const EXCLUDED_CHANNELS = [
  'Digital Motion',
  'Display',
  'Interactive',
  'Public Relations',
  'Visual Merchandising',
]

// Channel grouping configuration for Marketing vs Non-Marketing categorization
// Use canonical (mapped) channel names here
export const CHANNEL_GROUPS = {
  Marketing: [
    'Apps',
    'Broadcast',
    'Cross Channel',
    'Direct Mail',
    'Finds',
    'Gift Cards',
    'Magazine',
    'National Brand Target.com PDP',
    'Newspaper',
    'Out of Home',
    'Outtakes',
    'Owned Brand Target.com PDP',
    'Packaging',
    'Promo Marketing',
    'RedCard',
    'Roundel',
    'Social',
    'Store Experience Marketing',
    'Target Media Library',
    'Target.com Editorial',
    'Weekly Ad',
  ],
  'Non-Marketing': [
    'Communications',
    'Employer Brand Library',
    'Enterprise Operations',
    'Experiential',
    'Learning & Development',
    'Meetings',
    'Operational Signing',
    'Talent+Change',
    'Target Printing Services',
    'Target Properties',
  ],
}

// ============================================================================
// END OF CHANNEL FILTER CONFIGURATION
// ============================================================================

export const DEPARTMENT_CLASS_IDENTIFIER_GROUP = [
  FILTER_DEPARTMENT_KEY,
  FILTER_CLASS_KEY,
]

export const FACET_COLOR_KEY = 'colors'
export const FILTER_COLOR_BUCKET_KEY =
  'metadata.imageData.colorBuckets.bucket.nested'
export const FILTER_COLOR_HEX_KEY = 'metadata.imageData.colors.hex.nested'
export const FILTER_COLOR_HSV_KEY = 'metadata.imageData.colors.hsv.nested'

export const COLOR_IDENTIFIER_GROUP = [
  FILTER_COLOR_BUCKET_KEY,
  FILTER_COLOR_HEX_KEY,
  FILTER_COLOR_HSV_KEY,
]

export const FACET_IMAGEDATA_KEY = 'imageData'
export const FILTER_IMAGEDATA_ANIMALS_KEY = 'metadata.imageData.animals'
export const FILTER_IMAGEDATA_PEOPLE_KEY = 'metadata.imageData.people'
export const FILTER_IMAGEDATA_FOOD_KEY = 'metadata.imageData.withFood'

export const FILTER_UPLOAD_DATE_KEY = 'uploadedDate'
export const FILTER_IS_ARCHIVED_KEY = 'isArchived'
export const FILTER_READINESS_KEY = 'readiness'
export const FILTER_IS_REUSABLE_KEY = 'isReusable'
export const FILTER_IS_GEN_AI_READY_KEY = 'isGenAiReady'
export const FILTER_IS_METADATA_COMPLETENESS_KEY = 'metadataCompleteness'
export const FILTER_SOURCE_KEY = 'source'
export const FILTER_LIBRARIAN_STATUS_KEY = 'librarianReviewStatus'
export const FILTER_CLASSIFICATION_EXISTS_KEY =
  'metadata.assetClassification.classificationId.exists'
export const FILTER_CLASSIFICATION_MISSING_METADATA_KEY =
  'metadata.assetClassification.missingMetadata'
export const FILTER_ASSET_TYPE_KEY =
  'metadata.assetClassification.classificationId'
export const FILTER_CLASSIFICATION_KEY = 'classification'
export const FILTER_NO_CLASSIFICATION_ID =
  'metadata.assetClassification.classificationId.not'


export const FILTER_AI_CLASSIFICATION_TALENT = 'metadata.ai'
export const FILTER_AI_CLASSIFICATION = 'metadata.ai.assetClassification.classification'
export const FILTER_AI_CLASSIFICATION_KEYWORD = 'metadata.ai.assetClassification.classification.keyword'
export const FILTER_AI_TALENT = 'metadata.ai.assetTalent.isTalent'

// Librarian filter keys
export const FILTER_LIBRARIAN = 'librarian'
export const FILTER_IS_PRODUCT = 'metadata.ai.assetProduct.isProduct'
export const FILTER_IS_TALENT = 'metadata.ai.assetTalent.isTalent'
export const FILTER_IS_FOOD = 'metadata.ai.assetFood.isFood'
export const FILTER_IS_PETS = 'metadata.ai.assetPets.isPets'
export const FILTER_IS_UGC = 'isUGC'
export const FILTER_IS_DERIVATIVE = 'isDerivative'
export const FILTER_DRM_ID = 'metadata.usageInfo.drmId.exists'
export const FILTER_SECONDARY_CLASSIFICATION = 'metadata.assetClassification.secondaryClassification.exists'
export const FILTER_ASSET_TYPE = 'metadata.assetClassification.assetType.exists'
export const FILTER_MISSING_METADATA = 'missingMetadata'
export const FILTER_AI_CLASSIFICATION_OVERRIDE = 'metadata.ai.assetClassification.isAiClassificationUserOverridden'

export const REVIEW_TEMPLATE_KEY = 'template_id'

export const searchDefaultFilters = {
  isConfidential: ['false'],
  isLatestRevision: ['true'],
  creativeAssetStatus: ['Approved', 'Final'],
  status: ['ACTIVE'],
  isArchived: ['false']
}

export const ASSET_STATUS_ACTIVE = 'ACTIVE'
export const ASSET_STATUS_DELETED = 'DELETED_LCM'

export const searchDefaultPayload = {
  filters: searchDefaultFilters,
  sort_fields: {
    uploadedDate: 'desc',
  },
  search_term: '',
  search_type: 'ALL'
}

export const filterKeyLabels = {
  [FILTER_FILE_TYPE_KEY]: 'File Type',
  [FILTER_CHANNEL_KEY]: 'Channel',
  [FILTER_BRAND_KEY]: 'Brand',
  [FILTER_ASSET_TYPE_KEY]: 'Asset Type',
  [FILTER_UPLOAD_DATE_KEY]: 'Upload Date',
  [FILTER_DEPARTMENT_KEY]: 'Department',
  [FILTER_CLASS_KEY]: 'Class',
  [FACET_COLOR_KEY]: 'Colors',
  [FILTER_IS_ARCHIVED_KEY]: 'Archived',
  [FILTER_READINESS_KEY]: 'Readiness',
  [FILTER_IS_REUSABLE_KEY]: 'Reusable',
  [FILTER_IS_METADATA_COMPLETENESS_KEY]: 'Metadata',
  [FILTER_LIBRARIAN_STATUS_KEY]: 'Librarian Status',
  [FILTER_CLASSIFICATION_EXISTS_KEY]: 'Classification',
  [FILTER_CLASSIFICATION_MISSING_METADATA_KEY]: 'Metadata',
  [FILTER_SOURCE_KEY]: 'Source',
  [FILTER_NO_CLASSIFICATION_ID]: 'Classification Id',
  [FILTER_AI_CLASSIFICATION]: 'AI Classification',
  [FILTER_AI_TALENT]: 'AI Talent',
  [FILTER_LIBRARIAN]: 'Librarian',
  [FILTER_IS_PRODUCT]: 'isProduct',
  [FILTER_IS_TALENT]: 'isTalent',
  [FILTER_IS_FOOD]: 'isFood',
  [FILTER_IS_PETS]: 'isPets',
  [FILTER_AI_CLASSIFICATION_KEYWORD]: 'Classification',
  [FILTER_AI_CLASSIFICATION_OVERRIDE]: 'AI Classification Override',
  [FILTER_IS_DERIVATIVE]: 'isDerivative',
  [FILTER_DRM_ID]: 'DRM ID',
  [FILTER_SECONDARY_CLASSIFICATION]: 'Secondary Classification',
  [FILTER_ASSET_TYPE]: 'Asset Type',
  [FILTER_MISSING_METADATA]: 'Missing Metadata',
  [FILTER_IMAGEDATA_PEOPLE_KEY]: 'Asset Subject',
  [FILTER_IMAGEDATA_ANIMALS_KEY]: 'Asset Subject',
  [FILTER_IMAGEDATA_FOOD_KEY]: 'Asset Subject',
}

export const DEFAULT_COLORS = {
  '#FF0000': 'Red',
  '#FF8000': 'Orange',
  '#FFFF00': 'Yellow',
  '#99FF33': 'Light Green',
  '#00CC00': 'Green',
  '#00994D': 'Green Cyan',
  '#00FFFF': 'Cyan',
  '#007FFF': 'Light Blue',
  '#0000FF': 'Blue',
  '#7F00FF': 'Violet',
  '#FF00FF': 'Magenta',
  '#FF0080': 'Pink',
  '#000000': 'Black',
  '#FFFFFF': 'White',
  '#808080': 'Grey',
}

export const horizontalFiltersConfig = [
  {
    order: 1,
    id: 'assetType',
    key: FILTER_ASSET_TYPE_KEY,
    label: 'Asset Type',
    type: 'custom',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 2,
    id: 'file_type',
    key: FILTER_FILE_TYPE_KEY,
    label: 'File Type',
    type: 'default',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 3,
    id: 'Channel',
    key: FILTER_CHANNEL_KEY,
    label: 'Channel',
    type: 'default',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 4,
    id: 'Brand',
    key: FILTER_BRAND_KEY,
    label: 'Brand',
    type: 'default',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 5,
    id: 'upload_date',
    key: FILTER_UPLOAD_DATE_KEY,
    label: 'Upload Date',
    type: 'custom',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 6,
    id: 'Department',
    key: FILTER_DEPARTMENT_KEY,
    label: 'Department',
    type: 'default',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 7,
    id: 'archived',
    key: FILTER_IS_ARCHIVED_KEY,
    label: 'Lifecycle',
    type: 'default',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 8,
    id: 'readiness',
    key: FILTER_READINESS_KEY,
    label: 'Readiness',
    type: 'custom',
    filtersCount: Number(0),
    show: true,
  },
  {
    order: 9,
    id: 'ai_classification',
    key: FILTER_AI_CLASSIFICATION_TALENT,
    label: 'AI Classification',
    type: 'default',
    filtersCount: Number(0),
    show: false,
  },
  {
    order: 10,
    id: 'metadata_completeness',
    key: FILTER_IS_METADATA_COMPLETENESS_KEY,
    label: 'Metadata',
    type: 'default',
    filtersCount: Number(0),
    show: false,
  },
  {
    order: 11,
    id: 'librarian',
    key: FILTER_LIBRARIAN,
    label: 'Librarian',
    type: 'custom',
    filtersCount: Number(0),
    show: false,
  },
  {
    order: 12,
    id: 'classification',
    key: FILTER_CLASSIFICATION_KEY,
    label: 'Classification',
    type: 'custom',
    filtersCount: Number(0),
    show: false,
  },
]

export const SEARCH_TYPE_ALL = 'ALL'
export const SEARCH_TYPE_TCIN = 'TCIN'
export const SEARCH_TYPE_DPCI = 'DPCI'
export const SEARCH_TYPE_FILE_NAME = 'FILE_NAME'
export const SEARCH_TYPE_PROJECT_ID = 'PROJECT_ID'
export const SEARCH_TYPE_ASSET_ID = 'ASSET_ID'
export const SEARCH_TYPE_DOCUMENT_ID = 'DOCUMENT_ID'
export const SEARCH_TYPE_AI_METADATA = 'AI_METADATA'

export const searchTypeListForUsers = [
  { label: 'Default', value: SEARCH_TYPE_ALL, },
  { label: 'TCIN List', value: SEARCH_TYPE_TCIN },
  { label: 'DPCI List', value: SEARCH_TYPE_DPCI },
  { label: 'File Name List', value: SEARCH_TYPE_FILE_NAME },
  { label: 'Project ID List', value: SEARCH_TYPE_PROJECT_ID },
]

export const searchTypeAddonsForAdmins = [
  { label: 'Asset ID', value: SEARCH_TYPE_ASSET_ID },
  { label: 'Document ID', value: SEARCH_TYPE_DOCUMENT_ID },
  { label: 'AI Metadata', value: SEARCH_TYPE_AI_METADATA },
]

export const placeholderTextBySearchType = {
  [SEARCH_TYPE_ALL]: 'Enter a TCIN, DPCI, file name, project ID, or keywords',
  [SEARCH_TYPE_TCIN]: 'Enter one or many TCIN values, example: 12866294, 16867626',
  [SEARCH_TYPE_DPCI]: 'Enter one or many DPCI values, example: 060-17-4011, 062-02-0126',
  [SEARCH_TYPE_FILE_NAME]: 'Enter one or many file names with extension, example: 20230219_p21_Baby.pdf, 20230219_p21_Baby.pdf ',
  [SEARCH_TYPE_PROJECT_ID]: 'Enter project ID or part of a project ID, example: C-000518-01-006, C-000518-01',
  [SEARCH_TYPE_ASSET_ID]: 'Enter asset ID',
  [SEARCH_TYPE_DOCUMENT_ID]: 'Enter document ID',
  [SEARCH_TYPE_AI_METADATA]: 'Enter keywords to find assets based on AI generated text',
}

export const adminAccessFilterListKeys = [
  FILTER_IS_REUSABLE_KEY,
  FILTER_LIBRARIAN,
  FILTER_CLASSIFICATION_KEY
]

export const fileTypeDisplayOrder = ['Images', 'Documents', 'Multimedia', 'Other']

export const videoFileTypes = [
  'mp4',
  'mov',
]

export const aiClassificationFilterList = [
  { label: 'Outline', key: 'Outline' },
  { label: 'Environment', key: 'Environment' }
]

export const defaultSearchFilterPrompt = "You are an assistant that converts user queries into search filters. The user has access to a search system with the following filters:\n\nConvert the following natural language query into a JSON object of filters.\n\nUser Query:{inputString}\n\n{\"metadata.fileMetadata.fileType\":[\"gif\",\"jpg\",\"png\",\"psb\",\"psd\",\"tif\",\"ai\",\"eps\",\"indd\",\"pdf\",\"svg\",\"mov\",\"mp3\",\"mp4\",\"wav\",\"OTHER\",\"html\",\"idml\",\"txt\",\"unknown\",\"webp\",\"xlsx\",\"zip\"]}\n\n{\"metadata.projectInfo.channel\":[\"undefined\",\"Apps\",\"Beauty Boxes\",\"Broadcast\",\"Catalog\",\"Communications\",\"Cross Channel\",\"CrossChannel & Contract Fees\",\"Cross-Channel\",\"Digital Motion\",\"Digital Video\",\"Direct Mail\",\"Display\",\"EnterpriseOperations\",\"Experiential\",\"Experiential Marketing\",\"Finds\",\"Gift Cards\",\"In Store Marketing\",\"Interactive\",\"Learning &Development\",\"Magazine\",\"Meetings\",\"Newspaper\",\"Operational Signing\",\"Out ofHome\",\"Outtakes\",\"Packaging\",\"Promo\",\"Promo Marketing\",\"Promo Outtakes\",\"PublicRelations\",\"RedCard\",\"Roundel\",\"Roundel Metadata Tagging\",\"Social\",\"TCIN Photography\",\"Talent+Change\",\"TargetBranded Assets\",\"Target Media Library\",\"Target Printing Services\",\"Target Properties\",\"Target.com\",\"Target.comEditorial\"]}\n\n{\"metadata.itemInfo.brand.nested\": ${Automatically identify and include the brand mentioned in the query}}\n\n{\"Classification\":[\"Non-Product Image\",\"Background\",\"Environment with talent\",\"Environment without talent\",\"Events\",\"Events with talent\",\"Headquarters with talent\",\"Headquarters without talent\",\"Outline with talent\",\"Outline without talent\",\"Profile photo\",\"Set\",\"Store with talent\",\"Store without talent\",\"Product Video\",\"Caption\",\"Description\",\"With talent\",\"Without talent\",\"Non-Product Video\",\"Caption\",\"Description\",\"With talent\",\"Without talent\",\"Design File\",\"Dieline\",\"Graphic\",\"Icon\",\"Illustration\",\"Logo\",\"Style Guide\",\"Template\",\"Layout File\",\"Digital Campaign\",\"Packaging\",\"Packaging Excel document\",\"Packaging Library\",\"Packaging Reference Layout\",\"Packaging Toolkit\",\"Print campaign\",\"Signage\",\"Product Image\",\"Environment with talent\",\"Environment without talent\",\"Infographic\",\"Infographic with talent\",\"Outline with talent\",\"Outline without talent\",\"Non-Product Motion\",\"Environment with talent\",\"Environment without talent\",\"Outline with talent\",\"Outline without talent\",\"Product Motion\",\"Environment with talent\",\"Environment without talent\",\"Outline with talent\",\"Outline without talent\",\"Product Audio\",\"With talent\",\"Non-Product Audio\",\"With talent\"]}\n\n{\"Asset Subject\":{\"People\":[\"With\",\"Without\",\"No Preference\"],\"Food\":[\"With\",\"Without\",\"No Preference\"],\"Animal\":[\"With\",\"Without\",\"No Preference\"]}}\u200b\n\n{\"uploadedDate\":${For this filter please provide the output as a array of string in the form of a from and to date}}\u200b\n\n{\"metadata.imageData.colorBuckets.bucket.nested\":[\"Red\",\"Orange\",\"Yellow\",\"Light Green\",\"Green\",\"Green Cyan\",\"Cyan\",\"Light Blue\",\"Blue\",\"Violet\",\"Magenta\",\"Pink\",\"Black\",\"White\",\"Grey\"]}\n\n### Rules:\n- Automatically identify and include the brand mentioned in the query.\n- Only include filters that are clearly mentioned or can be inferred.\n- For relative dates (e.g., \"last month\", \"past 3 days\"), convert them to actual dates ( in the form of mm-dd-yyyy ) with reference to current date {current_date}.\n- Output only the JSON. No explanation or extra text.\n- The value of each filter in the json should always be an array of string.\n- The value of each filter in the json should always be an array of string.\n- If nothing matches, return an empty JSON {}."
